<template>
    <div>
        <!-- 表格 -->
        <el-table class="grayTableTile tableBox" v-loading="listLoading" :data="tableData" :row-class-name="handleRow" @sort-change="handleAgeSortChange" style="width:100%;">
            <!-- <el-table-column label="紧急度" min-width="90" sortable="custom">
                <template  slot-scope="scope">
                    <span class="mark" :class="scope.row.priority == 1 ? 'red' : scope.row.priority == 2 ? 'yellow' : scope.row.priority == 3 ? 'blue' : ''">{{scope.row.priority}}</span>
                </template>
            </el-table-column> -->
            <el-table-column label="任务名称" min-width="250" >
                <template slot-scope="scope">
                    <div class="title">
                        <div class="label">{{scope.row.taskName}}：</div>
                        <span>{{scope.row.subhead}}</span>
                    </div>
                    <div class="content">{{scope.row.createTimeStr}}</div>
                </template>
            </el-table-column>
            <el-table-column label="任务ID" min-width="70" >
                <template  slot-scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column label="任务分类" min-width="120" >
                <template  slot-scope="scope">
                    <span>{{scope.row.taskTypeName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="项目" min-width="100" >
                <template  slot-scope="scope">
                    <span>{{scope.row.projectName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="发起人" min-width="100" >
                <template  slot-scope="scope">
                    <span class="link" @click="showUserDetails(scope.row)">{{scope.row.createUserName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="完成时间" min-width="130" sortable="custom" prop='completeTime'><!-- sortable="custom" -->
                <template  slot-scope="scope">
                    <span>{{scope.row.completeTime}}</span>
                    <div style="color:#F56C6C">{{scope.row.delayCompleteTime}}</div>
                </template>
            </el-table-column>
                <el-table-column label="任务状态" min-width="100"> <!-- sortable="custom" -->
                <template slot-scope="scope">
                    <span class="status" :class="scope.row.status | statusColor">{{scope.row.status | statusType}}</span>
                </template>
            </el-table-column>
            <el-table-column label="设计师" min-width="120" v-if="(status == '' || status == 1 || status == 2 || status == 3) && status !== 0">
                <template  slot-scope="scope">
                    <span>{{scope.row.designerName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="迭代版本" min-width="100" > <!-- sortable="custom" v-if="(status == '' || status == 3)  && status !== 0"-->
                <template slot-scope="scope" v-if="scope.row.status == 3">
                    <span class="link" @click="handleIteration(scope.row)">{{scope.row.vnums}}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="110">
                <template slot="header" slot-scope="scope">
                    <span>共享资源库</span>
                    <el-popover popper-class="gray-popper" placement="top" width="300" trigger="hover" content="显示状态下该素材会同步素材中心，隐藏状态下不做同步">
                        <i class="el-icon-question" slot="reference" style="cursor: pointer;" />
                    </el-popover>
                </template>
                <template  slot-scope="scope">
                    <el-switch v-model="scope.row.share" :active-value="1" :inactive-value="0" :disabled="!scope.row.isShare" active-color="#13ce66" inactive-color="#ff4949" @change="handleShare(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="任务详情" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDetails(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-thumb" style="color:#F56C6C" v-if="scope.row.isBackout && accessPoint['applyme:delete']" @click="handleBackout(scope.row)">撤销</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="handlePaginationList" style="margin-top:0" />

        <!-- 用户详情 -->
        <el-dialog class="dialog" v-if="dialogUserDetails" title="用户信息" :visible.sync="dialogUserDetails" width="40vw">
            <el-form ref="userForm" :model="userForm" label-width="180px">
                <el-form-item label="姓名：">
                    <span>{{userForm.realname}}</span>
                </el-form-item>

                <!-- <el-form-item label="微信号：">
                    <span>{{userForm.name}}</span>
                </el-form-item> -->

                <el-form-item label="手机号：">
                    <span>{{userForm.phone}}</span>
                </el-form-item>

                <el-form-item label="邮箱：">
                    <span>{{userForm.email}}</span>
                </el-form-item>

                <!-- <el-form-item label="组织部门：">
                    <span>{{userForm.name}}</span>
                </el-form-item>

                <el-form-item label="职务名称：">
                    <span>{{userForm.name}}</span>
                </el-form-item> -->
            </el-form>
        </el-dialog>

        <!-- 迭代版本 -->
        <el-dialog class="dialog-version" v-if="dialogVersion" title="迭代版本记录" :visible.sync="dialogVersion" width="50vw" top="10vh">
            <el-scrollbar wrap-class="scrollbar-wrapper"  v-loading="versionLoading">
                <el-timeline v-if="versionsList.length > 0">
                    <el-timeline-item color="#008000" v-for="(item, index) in versionsList" :key="index" >
                        {{item.createTime}} &nbsp;&nbsp;&nbsp;
                        {{item.createUserName}} &nbsp;&nbsp;&nbsp;
                        {{item.status_name}}  &nbsp;&nbsp;&nbsp;
                        {{item.statusStr ? '原因：'+ item.statusStr : ''}}
                    </el-timeline-item>
                </el-timeline>

                <span v-else-if="versionsList.length == 0 && !versionLoading" style=" display:block; line-height: 60px; color: #909399; text-align:center">暂无迭代信息</span>
            </el-scrollbar>
        </el-dialog>
       
        <!-- 查看详情 -->
        <task-details ref="details" @againList="handleAgainList"></task-details>

    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import TaskDetails from './taskDetails'
import { artFlowModifyStatus_ajax, artFlowVersionList_ajax, artFlowModifyShare_ajax } from '@File~/api/file'
export default {
    components:{Pagination,TaskDetails},
    props: {
        source: {
            type: String,
            default: ''
        },
        status: {
            type: String | Number,
            default: ''
        }
    },
    data() {
        return {
            tableData:[],
            listLoading: false,
            total:0,
            listQuery:{
                pageNo:1,
                pageSize:10,
            },

            // 用户详细信息
            dialogUserDetails:false,
            userForm:{},

            dialogVersion: false,
            versionsList: [],
            versionLoading: true,

            accessPoint: this.$store.getters.accessPoint, //权限点
            sortType:'',
            sortProperty:''
        }
    },
    filters: {
        statusType(type) {
            const typeMap = {
                0 : '待分配',
                2 : '进行中',
                1 : '待确认',
                3 : '已完成',
                '-1' : '已拒绝'
            }
            return typeMap [type]
        },

        statusColor(type) {
            const typeMap = {
                0 : 'red',
                2 : 'blue',
                1 : 'purple',
                3 : 'green',
                '-1' : 'gray'
            }
            return typeMap [type]
        }
    },
    methods: {

        // 分页获取数据
        handlePaginationList() {
            this.$emit('paginationList')
        },

        // 刷新列表接口
        handleAgainList() {
            this.$emit('againList')
        },

        // 查看用户详细信息
        showUserDetails(row) {
            this.dialogUserDetails = true
            this.userForm = row.createUserInfo
        },

        // 查看迭代版本
        handleIteration(row) {
            this.versionsList = []
            this.dialogVersion = true
            this.versionLoading = true
            artFlowVersionList_ajax(row.id).then(response => {
                this.versionLoading = false
                if(response.code == 1) {
                    const data = JSON.parse(JSON.stringify(response.data))
                    let flag = null
                    let list = data.map((v,index) => {
                        
                        if(v.status == 2) {
                            if(flag) {
                                this.$set(v,'status_name','提交修改')
                            } else {
                                flag = index
                                this.$set(v,'status_name','分配任务')
                            }
                        }

                        if(v.status == 1) {
                           this.$set(v,'status_name','上传稿件')
                        }

                        if(v.status == 3) {
                           this.$set(v,'status_name','已确认稿件')
                        }

                        return v
                    });

                    list.forEach(e => {
                        if(e.status != 0) {
                            this.versionsList.push(e)
                        }
                    });
                }
            })
        },

        // 查看详情
        handleDetails(row) {
            this.$refs['details'].init(row)
        },

        // 撤销
        handleBackout(row) {
            this.$confirm('是否确认撤销？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const data = {
                    userId: this.$store.getters.userId,
                    flowId: row.id,
                    status: '-99',
                    statusStr:''
                }
                artFlowModifyStatus_ajax(data).then(response => {
                    if(response.code == 1) {
                        this.$emit('againList')
                    }
                })
            }).catch(() => {
                            
            });
           
        },

        // 监听排序变化
        handleAgeSortChange(e) {
            console.log(e);
            if (e.order) {
                // const order = e.order == 'ascending' ? 'asc' : 'desc'
                // this.caseTable.sort(sortKeys(e.prop, order))
                this.sortProperty = e.prop
                this.sortType = e.order == 'ascending' ? 'ASC' : 'DESC'
                this.$emit('againList')
            } else {
                this.sortProperty = ''
                this.sortType = ''
                this.$emit('againList')
            }
        },

        // 操作共享资源库分享
        handleShare(row) {
            console.log(row)
            artFlowModifyShare_ajax(row.id, row.share).then(response => {
                if(response.code == 1) {
                    this.$message({
                        message: row.share ? '共享成功' : '已取消共享',
                        type: 'success'
                    });
                }
            })
        },

        // 设置表格 行class
        handleRow({ row }) {
            // console.log('行====',row)
            let rowName = "";
            switch (row.status) {
                case 0:
                rowName = "red";
                break;
                case 2:
                rowName = "blue";
                break;
                case 1:
                rowName = "purple";
                break;
                case 3:
                rowName = "green";
                break;
                case -1:
                rowName = "gray";
                break;
                default:
                rowName = "";
            }
            return rowName;
        },
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .grayTableTile thead th{
        height: 46px;
        line-height: 46x;
    }
    ::v-deep .grayTableTile.el-table td{
        padding: 10px 0;
    }
    .grayTableTile{
        ::v-deep .red td:first-child {
            border-left: 4px solid #fb6c75;
        }
        ::v-deep .blue td:first-child {
            border-left: 4px solid#439DE2;
        }
        ::v-deep .purple td:first-child {
            border-left: 4px solid #876fff;
        }
        ::v-deep .green td:first-child {
            border-left: 4px solid #0ed27f;
        }
        ::v-deep .gray td:first-child {
            border-left: 4px solid#CCCCCC;
        }
    }

    .tableBox{
        .mark{
            font-weight: bold;
            border-radius: 50%;
            width:22px;
            height: 22px;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            &.red{
                border: 2px solid #fa5838;
                color: #fa5838;
            }
            &.yellow{
                color: #fc6;
                border: 2px solid #fc6;
            }
            &.blue{
                color: #5DCFFF;
                border: 2px solid #5DCFFF;
            }
        }
        .title{
            display: flex;
            flex-flow: row wrap;
            .label{
                font-size: 15px;
                font-weight: bold;
            }
        }
        .content{
            color: #a2a2a2;
        }
        .status{
            display: block;
            max-width: 120px;
            width: 100%;
            height: 28px;
            line-height: 28px;
            text-align: center;
            border-radius: 4px;
            color: #333;
            cursor: pointer;
            &.red{
                background: #ffe9eb;
            }
            &.purple{
                background: #f2ecfe;
            }
            &.blue{
               background: #e3f1fb;
            }
            &.green{
               background: #dbf8ec;
            }
            &.gray{
                background: #eeeeee;
            }
        }
        .link{
            cursor: pointer;
            color: #409eff;
        }
    }
    .dialog-version{
        ::v-deep .el-dialog__body{
            padding: 10px 20px 20px;
            height:calc(100vh - 25vh);
           
        }
        ::v-deep .el-scrollbar{
            height: 100%;
        }
        ::v-deep .scrollbar-wrapper {
            overflow-x: hidden !important;
        }
        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }
        ::v-deep .el-timeline{
            padding: 10px;
        }
    }
</style>